<template>
  <div class="card">
    <div class="card-header">
      <h3 class="cart-title">
        <a data-action="collapse">Personal address</a>
      </h3>
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a data-action="collapse"><i data-feather="chevron-down" /></a>
          </li>
        </ul>
      </div>
    </div>
    <div class="card-content collapse show">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-1 form-group required">
              <label
                class="form-label"
                for=""
              >Address </label>
              <textarea
                v-model="user.address"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-1 form-group required">
              <label
                class="form-label"
                for=""
              >City </label>
              <input
                v-model="user.city"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-1 form-group required">
              <label
                class="form-label"
                for=""
              >Postal Code </label>
              <input
                v-model="user.postal_code"
                type="text"
                class="form-control"
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-1 form-group required">
              <label
                class="form-label"
                for="select2-basic"
              >Country</label>
              <v-select
                v-model="user.country"
                label="name"
                :options="countries"
                :get-option-key="option => option.id"
                :reduce="option => option.id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  props: {
    user: { type: Object, required: true, default: () => {} },
  },
  computed: {
    ...mapGetters({
      countries: 'citizenships/items',
    }),
  },
  mounted() {
    if (this.countries.length === 0) {
      this.$store.dispatch('citizenships/fetch')
    }
  },
}
</script>

<style>

</style>
